import { ConsentStatus } from './consent-status.model';

export class CompanyBank {
  CompanyBankId: number;
  CompanyId: number;
  BankId: string;
  BankName: string;
  ConsentLink: string;
  ConsentLinkExpirationDate: Date;
  ConsentExpirationDate: Date;
  ConsentStatus: ConsentStatus;
  CronExpression: string;
  WindowBackward: string;
  WindowForward: string;

  constructor(companyId: number) {
    this.CompanyBankId = null;
    this.CompanyId = companyId;
    this.BankId = null;
    this.BankName = null;
    this.ConsentLink = null;
    this.ConsentLinkExpirationDate = null;
    this.ConsentExpirationDate = null;
    this.ConsentStatus = new ConsentStatus();
    this.CronExpression = '0 0 4,12 * * ?';
    this.WindowBackward = '60';
    this.WindowForward = '30';
  }
}
